module.exports = __webpack_public_path__ + "public/adminIcons/Totallistings.svg?26115312";